import styled from 'styled-components';

export const buttonStyles = {
  width: '100%'
};

export const StyledFieldset = styled.fieldset`
  padding: 1rem 5%;
  margin: 1rem 0;
`;

export const BoldSpan = styled.span`
  font-weight: bold;
`;
